import '../index.css';

const Header = () => {
    return (
        <header className='heading-2 header'>
            Manage Addresses
        </header>
    );
}

export { Header };